var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Box from '@mui/material/Box';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { cpaService } from 'services/api/cpa-service';
import { CUSTOM_PREFIXES } from 'utils/cpa-utils';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { CpaProductMode } from '../CpaProduct/CpaProductReducer';
import styles from './CpaSearch.module.scss';
import { CpaSearchAddForm } from './CpaSearchAddForm/CpaSearchAddForm';
import { CpaSearchEditForm } from './CpaSearchEditForm/CpaSearchEditForm';
/**
 * Landing page for CPA, where user tries to create or update a product
 */
export function CpaSearch() {
    var _this = this;
    var _a;
    var location = useLocation();
    var productNumber = (_a = location === null || location === void 0 ? void 0 : location.search.split('=')[1]) !== null && _a !== void 0 ? _a : '';
    var _b = useState(false), addInProgress = _b[0], setAddInProgress = _b[1];
    var _c = useState(false), editInProgress = _c[0], setEditInProgress = _c[1];
    var getCpn = function (customProductType) { return __awaiter(_this, void 0, Promise, function () {
        var cpnRsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setAddInProgress(true);
                    return [4 /*yield*/, cpaService.generateCpn(CUSTOM_PREFIXES[customProductType].prefix)];
                case 1:
                    cpnRsp = _a.sent();
                    return [2 /*return*/, cpnRsp.body.customProductNumber];
            }
        });
    }); };
    var navigate = useNavigate();
    return (_jsxs(Box, __assign({ className: styles.container }, { children: [_jsx("h1", { children: " Custom Product Application" }), _jsx("p", { children: "This application allows custom product (Specials and Work Orders) to be created or maintained in the Publication Layer, including pricing maintenance." }), _jsx(CpaSearchAddForm, { addInProgress: addInProgress, onSubmit: function (stndProdRef, customPrefixType, validationData) { return __awaiter(_this, void 0, void 0, function () {
                    var cpn;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getCpn(customPrefixType)];
                            case 1:
                                cpn = _a.sent();
                                sessionStorage.setItem("".concat(cpn, "_inAddEditMode"), CpaProductMode.ADD);
                                sessionStorage.setItem("".concat(cpn, "_validationData"), JSON.stringify(validationData));
                                navigate("/cpa/product/".concat(cpn, "/").concat(stndProdRef, "?tab=description"));
                                return [2 /*return*/];
                        }
                    });
                }); }, productNumber: productNumber }), _jsx("h2", { children: "- OR - " }), _jsx(CpaSearchEditForm, { editInProgress: editInProgress, onSubmit: function (cpn) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        setEditInProgress(true);
                        sessionStorage.setItem("".concat(cpn, "_inAddEditMode"), CpaProductMode.EDIT);
                        navigate("/cpa/product/".concat(cpn, "?tab=description"));
                        setEditInProgress(false);
                        return [2 /*return*/];
                    });
                }); } }), (addInProgress || editInProgress) && _jsx(LoadingSpinner, { indicatorSize: 10 })] })));
}
